






















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class SupplierInfo extends Vue {
  @Prop(Object) public supplier!: object;
  @Prop({ type: String, default: 'full' }) public mode!: 'full' | 'minimal';
}
